var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNavbrand(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icon_Set",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#F0C48A;}\n\t.st1{fill:#FD919E;}\n\t.st2{fill:#E8677D;}\n\t.st3{fill:#4C4372;}\n\t.st4{fill:#D3E6F8;}\n\t.st5{fill:#A4CFF2;}\n\t.st6{fill:#FFFFFF;}\n\t.st7{fill:#7BABF1;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 256,
    cy: 256,
    r: 207
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 201.3,
    y: 197.422,
    className: "st1",
    width: 109.4,
    height: 118.765
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 281.327,
    y: 197.422,
    className: "st2",
    width: 29.373,
    height: 117.961
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M306.413,434.952H205.587c-12.786,0-23.151-10.365-23.151-23.151v-95.614h147.128v95.614 C329.564,424.587,319.199,434.952,306.413,434.952z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M329.564,197.422H182.436v-95.614c0-12.786,10.365-23.151,23.151-23.151h100.826 c12.786,0,23.151,10.365,23.151,23.151V197.422z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M329.564,197.422h-26.47V77.048l0,0c14.619,0,26.47,11.851,26.47,26.47V197.422z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M329.564,315.383h-26.47v120.373l0,0c14.619,0,26.47-11.851,26.47-26.47V315.383z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M329.564,203.284H182.436c-3.238,0-5.863-2.625-5.863-5.863v-95.615c0-15.998,13.015-29.013,29.013-29.013 h100.826c15.998,0,29.013,13.015,29.013,29.013v95.615C335.427,200.659,332.802,203.284,329.564,203.284z M188.299,191.559 h135.403v-89.752c0-9.532-7.756-17.288-17.288-17.288H205.587c-9.533,0-17.288,7.756-17.288,17.288V191.559z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M306.413,440.814H205.587c-15.998,0-29.013-13.015-29.013-29.013v-95.614c0-3.238,2.625-5.863,5.863-5.863 h147.128c3.238,0,5.863,2.625,5.863,5.863v95.614C335.427,427.799,322.411,440.814,306.413,440.814z M188.299,322.05v89.751 c0,9.532,7.755,17.288,17.288,17.288h100.826c9.532,0,17.288-7.756,17.288-17.288V322.05H188.299z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M310.7,322.05H201.3c-3.238,0-5.863-2.625-5.863-5.863V197.422c0-3.238,2.625-5.863,5.863-5.863H310.7 c3.238,0,5.863,2.625,5.863,5.863v118.765C316.563,319.425,313.938,322.05,310.7,322.05z M207.162,310.324h97.676v-107.04 h-97.676V310.324z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M256.293,512c-3.238,0-5.863-2.625-5.863-5.863v-71.186c0-3.238,2.625-5.863,5.863-5.863 c3.238,0,5.862,2.625,5.862,5.863v71.186C262.155,509.375,259.531,512,256.293,512z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M256.293,82.911c-3.238,0-5.863-2.625-5.863-5.863V5.863c0-3.238,2.625-5.863,5.863-5.863 c3.238,0,5.862,2.625,5.862,5.863v71.186C262.155,80.286,259.531,82.911,256.293,82.911z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M329.564,381.448H182.436c-3.238,0-5.863-2.625-5.863-5.863c0-3.238,2.625-5.863,5.863-5.863h147.128 c3.238,0,5.863,2.625,5.863,5.863C335.427,378.823,332.802,381.448,329.564,381.448z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M327.898,143.097H182.729c-3.238,0-5.863-2.625-5.863-5.863c0-3.238,2.624-5.863,5.863-5.863h145.169 c3.238,0,5.863,2.625,5.863,5.863C333.76,140.472,331.135,143.097,327.898,143.097z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M310.7,289.021H201.3c-3.238,0-5.863-2.625-5.863-5.863c0-3.238,2.625-5.863,5.863-5.863H310.7 c3.238,0,5.863,2.625,5.863,5.863C316.563,286.396,313.938,289.021,310.7,289.021z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M310.7,236.312H201.3c-3.238,0-5.863-2.625-5.863-5.863s2.625-5.863,5.863-5.863H310.7 c3.238,0,5.863,2.625,5.863,5.863S313.938,236.312,310.7,236.312z"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavbrand);
export default __webpack_public_path__ + "static/media/navbrand.e62f25b4601d178dc132bb61b296e2d3.svg";
export { ForwardRef as ReactComponent };